import { Actions, ActionTypes } from './actions';
import { State, initialState } from './state';
import { AssignmentStatusTypes } from './constants';
import * as _ from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';

export function claimCmeCeReducer(state = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypes.OPEN_CONFIRMATION_WINDOW: {
            return {
                ...state,
                showConfirmation: true,
            };
        }
        case ActionTypes.CLOSE_CONFIRMATION_WINDOW: {
            return {
                ...state,
                showConfirmation: false,
            };
        }
        case ActionTypes.OPEN_HELP_WINDOW: {
            return {
                ...state,
                showHelp: true,
            };
        }
        case ActionTypes.CLOSE_HELP_WINDOW: {
            return {
                ...state,
                showHelp: false,
            };
        }
        case ActionTypes.GET_CONTEXTUAL_HELP_SUCCESS: {
            return {
                ...state,

                contextualHelpHTML: action.payload,
            };
        }
        case ActionTypes.GET_CONTEXTUAL_HELP_FAILURE: {
            return {
                ...state,
                error: action.payload,
            };
        }
        case ActionTypes.CLEAR_ERROR: {
            return {
                ...state,
                error: null,
            };
        }
        case ActionTypes.GET_LAB_INFO_SUCCESS: {
            return {
                ...state,
                derivedLabAffiliation: action.payload,
            };
        }
        case ActionTypes.GET_LAB_INFO_FAILURE: {
            return {
                ...state,
                derivedLabAffiliation: null,
                error: null,
            };
        }
        case ActionTypes.GET_LAB_AFFILIATIONS_SUCCESS: {
            return {
                ...state,
                labAffiliations: action.payload,
            };
        }
        case ActionTypes.GET_LAB_AFFILIATIONS_FAILURE: {
            return {
                ...state,
                labAffiliations: null,
                error: action.payload,
            };
        }
        case ActionTypes.ASSIGN_KIT_TO_ACTIVITY: {
            return {
                ...state,
                showConfirmation: false,
                assignmentStatus: AssignmentStatusTypes.INIT,
                activityValidation: null,
            };
        }
        case ActionTypes.ASSIGN_KIT_TO_ACTIVITY_SUCCESS: {
            console.log('ASSIGN_KIT_TO_ACTIVITY_SUCCESS', action);
            return {
                ...state,
                showConfirmation: false,
                assignmentStatus:
                    action.payload.validationCode === 0 ? AssignmentStatusTypes.SUCCESS : AssignmentStatusTypes.FAILURE,
                activityValidation: action.payload,
            };
        }
        case ActionTypes.ASSIGN_KIT_TO_ACTIVITY_FAILURE: {
            console.log('ASSIGN_KIT_TO_ACTIVITY_FAILURE', action);
            let error = null;

            const status = _.get(action, 'payload.status', null);

            if (status !== 400) {
                error = action.payload;
            }

            return {
                ...state,
                showConfirmation: false,
                assignmentStatus: AssignmentStatusTypes.FAILURE,
                activityValidation: action.payload.error,
                error: {error},
            };
        }
        case ActionTypes.GET_ACTIVITY_REDIRECT_URL_SUCCESS: {
            return {
                ...state,
                activityRedirectUrl: action.payload,
            };
        }
        case ActionTypes.GET_ACTIVITY_REDIRECT_URL_FAILURE: {
            const httpErrorResponse = action.payload as HttpErrorResponse;

            if (httpErrorResponse && httpErrorResponse.status === 302) {
                return {
                    ...state,
                    activityRedirectUrl: httpErrorResponse.error,
                };
            }
            return {
                ...state,
                error: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
